import { all, put, takeLatest, call, select } from '@redux-saga/core/effects';
import {
  fetchOutlookCalendarMetadata,
  connectOutlookCalendar,
  disconnectOutlookCalendar,
  reconnectOutlookCalendar,
} from '../../routines/integrations/outlookCalendarRoutines';
import { request } from '../../../common/util/RestClient';
import envConfig from '../../../config';
import {
  INTEGRATION_TYPE,
  INTEGRATION_VENDORS,
} from '../../../common/constants/IntegrationConstants';
import { selectLoggedInUser } from '../../selectors/userSelector';
import { fetchIntegrations } from '../../routines/integrations/integrationDataRoutines';

function* fetchOutlookCalendarMetadataSaga() {
  try {
    const vendor = INTEGRATION_VENDORS.OUTLOOK_CALENDAR;
    const url = `${envConfig.APIG_URL}integration/types/scheduling/vendors/${vendor}/integration-metadata`;
    const { data: metadata } = yield call(request, url);

    yield put(fetchOutlookCalendarMetadata.success({ metadata }));
  } catch (error) {
    yield put(fetchOutlookCalendarMetadata.failure({ error }));
  }
}

function* connectOutlookCalendarSaga(action) {
  try {
    const { code, syncType, vendor } = action.payload;
    const { userId } = yield select(selectLoggedInUser);

    const url = `${envConfig.APIG_URL}integration/users/${userId}/service-integrations`;

    // This config for Outlook calendar integration testing
    const config = {
      method: 'POST',
      payload: {
        type: INTEGRATION_TYPE.SCHEDULING,
        vendor: vendor || INTEGRATION_VENDORS.OUTLOOK_CALENDAR,
        integrationContext: {
          token: code,
          syncType,
        },
      },
    };

    const response = yield call(request, url, config);

    yield put(
      connectOutlookCalendar.success({
        integration: response,
        successMessage: 'Outlook Calendar Integration connected successfully',
      })
    );

    yield put(fetchIntegrations());
  } catch (error) {
    yield put(connectOutlookCalendar.failure({ error }));
  }
}

function* reconnectOutlookCalendarSaga(action) {
  try {
    const { integrationId, code, syncType, vendor } = action.payload;
    const { userId } = yield select(selectLoggedInUser);

    const url = `${envConfig.APIG_URL}integration/users/${userId}/service-integrations/${integrationId}`;

    const config = {
      method: 'PUT',
      payload: {
        type: INTEGRATION_TYPE.SCHEDULING,
        vendor: vendor || INTEGRATION_VENDORS.OUTLOOK_CALENDAR,
        integrationContext: {
          token: code,
          syncType,
        },
      },
    };

    const { data: integration } = yield call(request, url, config);

    yield put(
      connectOutlookCalendar.success({
        integration,
        successMessage: 'Outlook Calendar Integration reconnected successfully',
      })
    );

    yield put(fetchIntegrations());
  } catch (error) {
    yield put(connectOutlookCalendar.failure({ error }));
  }
}

function* disconnectSaga(action) {
  const { userId, integrationId } = action.payload;
  try {
    const url = `${envConfig.APIG_URL}integration/users/${userId}/service-integrations/${integrationId}`;

    const config = {
      method: 'DELETE',
    };

    yield call(request, url, config);

    yield put(
      disconnectOutlookCalendar.success({
        successMessage: 'Integration disconnected successfully',
      })
    );

    yield put(fetchIntegrations());
  } catch (error) {
    yield put(disconnectOutlookCalendar.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchOutlookCalendarMetadata.TRIGGER,
      fetchOutlookCalendarMetadataSaga
    ),
    takeLatest(connectOutlookCalendar.TRIGGER, connectOutlookCalendarSaga),
    takeLatest(reconnectOutlookCalendar.TRIGGER, reconnectOutlookCalendarSaga),
    takeLatest(disconnectOutlookCalendar.TRIGGER, disconnectSaga),
  ]);
}
